import React from "react";
import "./About.css";
import bgImage from "../assets/bg1.png";

export default function About() {
  return (
    <div className="about-page">

      {/* HERO */}
      <header
        className="about-hero"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="hero-container">
          <h1>ABOUT OMKAR ABRASIVES</h1>
          <p>
            Committed to quality, capacity, and capability in abrasives manufacturing.
          </p>
        </div>
      </header>

      <main className="about-container">

        {/* PRODUCTION CAPACITY */}
        <section className="section">
          <h2>Production Capacity and Capabilities</h2>

          <p>
            OMKAR ABRASIVES boasts a robust manufacturing capacity,
            capable of producing between <strong>1000 to 1200 tons</strong>
            of abrasive grain annually. This output is supported by
            an in-house laboratory ensuring top-tier quality.
          </p>

          <div className="equipment">
            <h3>Advanced Equipment</h3>
            <ul>
              <li>
                <strong>Vibrating Machines:</strong> From Dalal Engineering.
              </li>
              <li>
                <strong>Ultrasonic Equipment:</strong> From Roop Sonic.
              </li>
            </ul>
          </div>
        </section>

        {/* PRODUCT RANGE */}
        <section className="section">
          <h2>Product Range and Applications</h2>

          <ul className="product-list">
            <li><strong>Silicon Carbide:</strong> Cutting, grinding, polishing</li>
            <li><strong>Polishing Grain:</strong> Smooth finishing</li>
            <li><strong>Emery Powder:</strong> Industrial polishing</li>
            <li><strong>Foundry Grade SiC:</strong> Foundry applications</li>
            <li><strong>Aluminium Oxide Powder:</strong> High hardness abrasive</li>
          </ul>

          <div className="product-note">
            <p>
              Green and Black Silicon Carbide grains are essential for bonded
              abrasive tools such as grinding wheels, polishing blocks,
              and refractory applications.
            </p>
            <p>
              Metallurgical grade silicon carbide serves as a dual source
              of silicon and carbon in foundry iron production.
            </p>
            <p>
              White, Brown, Pink, and Blue Aluminum Oxide variants
              provide precision grinding for different industrial uses.
            </p>
            <p>
              Magnesium Oxide (MgO), Boron Carbide, Silica Powder,
              Garnet grains, and Synthetic abrasives serve diverse
              high-temperature, abrasive, and metallurgical industries.
            </p>
          </div>
        </section>

        {/* PRODUCT DETAILS */}
        <section className="section">
          <h2>Product Details</h2>

          <div className="details-grid">
            <div className="detail-card">
              <h4>Packaging Size</h4>
              <p>Customizable based on customer needs</p>
            </div>

            <div className="detail-card">
              <h4>Colour</h4>
              <p>Standard black & other variants</p>
            </div>

            <div className="detail-card">
              <h4>Packaging Type</h4>
              <p>Durable sacks & industrial packaging</p>
            </div>
          </div>

{/* GRAIN SIZE TABLE */}
<div className="grain-table-wrapper">
  <h3 className="grain-title">Grain Size</h3>

  <table className="grain-table">
    <thead>
      <tr>
        <th>Coarse</th>
        <th>Medium</th>
        <th>Fine</th>
        <th>Very Fine</th>
        <th>Ultra Fine</th>
      </tr>
    </thead>

    <tbody>
      <tr><td>8</td><td>30</td><td>70</td><td>240</td><td>1000</td></tr>
      <tr><td>10</td><td>36</td><td>80</td><td>280</td><td>1200</td></tr>
      <tr><td>12</td><td>40</td><td>90</td><td>320</td><td>1500</td></tr>
      <tr><td>14</td><td>46</td><td>100</td><td>400</td><td>2000</td></tr>
      <tr><td>16</td><td>54</td><td>120</td><td>500</td><td>2500</td></tr>
      <tr><td>18</td><td>60</td><td>150</td><td>600</td><td>3000</td></tr>
      <tr><td>20</td><td>-</td><td>180</td><td>700</td><td>-</td></tr>
      <tr><td>24</td><td>-</td><td>220</td><td>800</td><td>-</td></tr>
    </tbody>
  </table>
</div>
        </section>

      </main>
    </div>
  );
}
